// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import TabNavigation from '../../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../../shared/services/pip-navigation-helper';
import {hasAccess} from '../../../../shared/services/security';

const OpenPipsHeader = props => {

    const countObject = {
        laborAdditive: props.laborAdditivePipProductsCount,
        openPips: props.pipProductsCount,
        pipSearch: props.searchResultsCount
    };

    return (
        <header className='open-pips-header'>
            <TabNavigation
                tabs={getNavigationTabs(countObject, props.hasSearchResults, hasAccess(props.security, 'PIP', 'PIP_LABOR_ADD_SUMM'))}
            />
        </header>
    );

};

OpenPipsHeader.displayName = 'OpenPipsHeader';
OpenPipsHeader.propTypes = {
    hasSearchResults: PropTypes.bool.isRequired,
    laborAdditivePipProductsCount: PropTypes.number.isRequired,
    pipProductsCount: PropTypes.number.isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default OpenPipsHeader;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-main/open-pips-header.js